import React, {Fragment} from "react";
import StepQuestion from "components/Step/StepQuestion";
import StepButton from "components/Step/StepButton";
import IdTypeEnum, {getDocumentNameByIdType} from "domain/Customer/IdTypeEnum";
import {RegistrationElements} from "domain/Registerv2/RegistrationElements";


export default class DocumentTypeStep extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.btnClick = this.btnClick.bind(this);
    }

    btnClick(idType) {

        let idExpiry = this.props[RegistrationElements.ID_EXPIRY];
        let nationality = this.props[RegistrationElements.NATIONALITY];

        let data = {[RegistrationElements.ID_TYPE]: idType};

        if (idType === IdTypeEnum.SA_ID
            || idType === IdTypeEnum.FOREIGN_ID
        ) {
            data[RegistrationElements.ID_EXPIRY] = "9999-01-01"
        } else {
            if (idExpiry === "9999-01-01") {
                data[RegistrationElements.ID_EXPIRY] = "";
            }
            if (nationality === "ZAF") {
                data[RegistrationElements.NATIONALITY] = "";
            }
        }

        if (this.props.onNextClick) this.props.onNextClick(data);
    }

    render() {
        return <Fragment>
            <StepQuestion>
                Which of the following documents do you have to provide us?
            </StepQuestion>
            {
                IdTypeEnum.values().map(singleIdType => {
                    let idType = IdTypeEnum[singleIdType];
                    return <StepButton
                        key={idType}
                        onClick={() => {
                            this.btnClick(idType);
                        }}
                    >
                        {getDocumentNameByIdType(idType)}
                    </StepButton>
                })
            }
            <StepButton
                color={"secondary"}
                onClick={this.props.onBackClick}
            >
                {"Back"}
            </StepButton>
        </Fragment>
    }
}
